module.exports = __webpack_public_path__ + "img/Broadside-tiled.b4bbfeb8.png";